export interface Bonus {
  tag: string
  title: string
  tagline: string
  intro: string
  items: string[]
  value: string
  image: string
}

export const bonuses: Bonus[] = [
  {
    tag: 'BONUS #1',
    title: 'RENAL RED FLAG CARDS™',
    tagline: 'Quickly identify the situations that deserve closer attention.',
    intro: 'A collection of visual reference cards organized around:',
    items: [
      'Important warning signs',
      'Situations requiring reassessment',
      'Escalation considerations',
      'Monitoring triggers',
      'Referral considerations',
    ],
    value: '$37',
    image:
      'https://cdn.magicpatterns.com/uploads/65A7QAgKgA9J2E2QETUR12/BONUS_1_RENALDESK-EN.png',
  },
  {
    tag: 'BONUS #2',
    title: 'RENAL MEDICATION DECISION CARDS™',
    tagline: 'Stop searching through medication information one drug at a time.',
    intro:
      'A rapid-reference collection organized around renal-function considerations for commonly encountered medications. Includes categories such as:',
    items: [
      'Diabetes medications',
      'Antihypertensives',
      'Antibiotics',
      'Anticoagulants',
      'Analgesics',
      'Other commonly used medications',
    ],
    value: '$47',
    image:
      'https://cdn.magicpatterns.com/uploads/8dxW36Rv1UtJYioMeoCp1P/BONUS_2_RENALDESK-EN.png',
  },
  {
    tag: 'BONUS #3',
    title: 'RENAL CONSULTATION SCRIPTS™',
    tagline: 'Explain complex kidney questions with greater clarity.',
    intro: 'Practical communication frameworks for questions such as:',
    items: [
      '“What does this kidney result mean?”',
      '“Will this get worse?”',
      '“Why do I need this medication?”',
      '“What can I do to protect my kidneys?”',
      '“Will I need dialysis?”',
    ],
    value: '$27',
    image:
      'https://cdn.magicpatterns.com/uploads/3ZC1uY15xRJnFCvdiAS7MH/BONUS_3_RENALDESK-EN.png',
  },
  {
    tag: 'BONUS #4',
    title: 'THE 25 RENAL DECISION PITFALLS™',
    tagline: 'Recognize the common decision traps before they disrupt your consultation.',
    intro: 'A practical error-prevention guide covering:',
    items: [
      'Initial assessment',
      'CKD classification',
      'Medication decisions',
      'Laboratory interpretation',
      'Nephroprotection',
      'Monitoring, follow-up and referral',
      'For every pitfall: what commonly happens → why it matters → what to review instead',
    ],
    value: '$47',
    image:
      'https://cdn.magicpatterns.com/uploads/oC16p1k31DNSr8cpNmacj2/BONUS_4_RENALDESK-EN.png',
  },
  {
    tag: 'BONUS #5',
    title: 'THE MASTER RENAL VISIT CHECKLIST™',
    tagline: 'Never wonder whether you forgot an important part of the consultation.',
    intro: 'A printable end-to-end checklist covering:',
    items: [
      'Initial assessment',
      'Laboratory review',
      'Medication review',
      'Risk assessment',
      'Decision points',
      'Monitoring and follow-up',
      'Referral considerations',
      'Documentation and patient communication',
    ],
    value: '$37',
    image:
      'https://cdn.magicpatterns.com/uploads/124tYR6fKxoHJuw3rJuafS/BONUS_5_RENALDESK-EN.png',
  },
]
